import { alpha, Theme } from "@mui/material";

export const getDisplayOverrides = (theme: Theme) => ({
  MuiChip: {
    styleOverrides: {
      root: {
        color: theme.palette.mode === "dark" ? "#1D1D1D" : "#000000",
        backgroundColor: theme.palette.mode === "dark" ? "#a7a7a7" : undefined,
      },
      deleteIcon: {
        color: theme.palette.mode === "dark" ? "#464646" : undefined,
         "&:hover": {
            color: theme.palette.mode === "dark" ? "#FFFFFF" : undefined,
         },
      },
    },
  },
  MuiAlert: {
    styleOverrides: {
      icon: {
        color: theme.palette.mode === "dark" ? theme.palette.highlight : "#FFBF00",
        "& .MuiAlert-icon": {
          color: "#ffa726",
        },
      },
    },
  },
   MuiAlertTitle: {
    styleOverrides: {
      root: {
        color: theme.palette.mode === "dark" ? theme.palette.highlight : undefined,
        fontWeight: theme.palette.mode === "dark" ? "bold" : undefined,
      },
    },
  },
  MuiTypography: {
    styleOverrides: {
      root: {
        color: theme.palette.mode === "dark" ? "#ffffff" : "#1D1D1D",
      },
      h6: {
        color: theme.palette.mode === "dark" ? "#FFFFFF" : theme.palette.highlight,
        "& a": {
          color: theme.palette.mode === "dark" ? "#FFFFFF" : theme.palette.highlight,
          fontWeight: 600,
          transition: "color 0.2s ease-in-out",
          "&:hover": {
            color: "#00C2FF",
            textDecoration: "underline",
          },
        },
      },
    },
  },
   MuiCardContent: {
    styleOverrides: {
      root: {
        padding: "16px",
      },
    },
  },
  MuiPaginationItem: {
    styleOverrides: {
      root: {
        "&:hover": {
          backgroundColor: alpha(theme.palette.highlight, 0.16),
          color: theme.palette.text.primary,
        },
      },
    },
  },
});
